import React, { useState } from 'react';
import { Link } from 'react-router-dom';


const Realisations = () => {
  const [activeFilter, setActiveFilter] = useState('tous');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProject, setSelectedProject] = useState(null);

  const projectsPerPage = 6;

  const projects = [
    {
      id: 1,
      title: "Peinture Logo Sococim",
      description: "",
      service: "peinture",
      location: "",
      date: "",
      status: "Terminé",
      imageBefore: "https://res.cloudinary.com/dizovx4yi/image/upload/v1747860802/sococim_iqg01z.jpg",
      detailedDescription:
        "Projet complet de rénovation de la toiture d'une maison ancienne située dans le centre-ville de Paris. La mission incluait la dépose des éléments endommagés, le renforcement structurel de la charpente, et la pose de nouvelles tuiles traditionnelles.",
      challenges:
        "La principale difficulté était de travailler sur une charpente ancienne fragilisée par les années et les infiltrations d'eau. Les conditions météorologiques hivernales ont également compliqué le chantier.",
      solutions:
        "Nous avons renforcé les éléments structurels de la charpente avec des techniques modernes tout en préservant son aspect traditionnel. Un système d'échafaudage couvert a été mis en place pour protéger le chantier des intempéries.",
      duration: "6 semaines",
      testimonial: {
        name: "Jean-Pierre Martin",
        rating: 5,
        comment:
          "Excellent travail réalisé par l'équipe d'EDMF pour la réfection de notre toiture. Malgré les conditions météorologiques difficiles, ils ont respecté les délais et le budget. Très professionnels et à l'écoute.",
        date: "Février 2025",
      },
    },
    {
      id: 2,
      title: "Peinture extérieure",
      description: "",
      service: "peinture",
      location: "",
      date: "",
      status: "Terminé",
      imageBefore: "https://res.cloudinary.com/dizovx4yi/image/upload/v1747861108/bandes-rouge-blanc_ugdxg0.jpg",
      detailedDescription:
        "Projet complet de rénovation de la toiture d'une maison ancienne située dans le centre-ville de Paris. La mission incluait la dépose des éléments endommagés, le renforcement structurel de la charpente, et la pose de nouvelles tuiles traditionnelles.",
      challenges:
        "La principale difficulté était de travailler sur une charpente ancienne fragilisée par les années et les infiltrations d'eau. Les conditions météorologiques hivernales ont également compliqué le chantier.",
      solutions:
        "Nous avons renforcé les éléments structurels de la charpente avec des techniques modernes tout en préservant son aspect traditionnel. Un système d'échafaudage couvert a été mis en place pour protéger le chantier des intempéries.",
      duration: "6 semaines",
      testimonial: {
        name: "Jean-Pierre Martin",
        rating: 5,
        comment:
          "Excellent travail réalisé par l'équipe d'EDMF pour la réfection de notre toiture. Malgré les conditions météorologiques difficiles, ils ont respecté les délais et le budget. Très professionnels et à l'écoute.",
        date: "Février 2025",
      },
    },
    // Ajoutez ici les autres projets similaires...
  ];

  const filteredProjects =
    activeFilter === "tous"
      ? projects
      : projects.filter((project) => project.service === activeFilter);

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(
    indexOfFirstProject,
    indexOfLastProject
  );

  const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] md:h-[600px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          role="img"
          aria-label="Nos réalisations en bâtiment et rénovation"
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dizovx4yi/image/upload/v1747864617/7f0c7412-34fb-4ce8-808a-3ce81cdb1f65_kdmtan.png')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#2D2A5D]/90 to-transparent"></div>
        </div>
        <div className="container mx-auto md:px-4 h-full flex items-center relative z-10">
          <div className="w-full max-w-2xl text-white">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold mt-12 mb-3 md:mb-4">
              Nos Réalisations
            </h1>
            <p className="text-md md:text-lg mb-6 md:mb-8">
              Découvrez notre portfolio de projets réalisés avec passion et expertise. Chaque réalisation témoigne de notre engagement pour la qualité et le savoir-faire.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <Link
                to="/"
                className="flex items-center text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="fas fa-arrow-left mr-2"></i> Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Filtres */}
      <section className="py-8 bg-gray-50 sticky top-0 z-20 shadow-md">
        <div className="container mx-auto md:px-4">
          <div className="flex flex-wrap items-center justify-between">
            <div className="w-full md:w-auto mb-4 md:mb-0">
              <button
                onClick={() => setActiveFilter("tous")}
                className={`px-6 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeFilter === "tous"
                    ? "bg-[#2D2A5D] text-white"
                    : "bg-white text-gray-700 hover:bg-gray-200"
                }`}
              >
                Tous les projets
              </button>
              <button
                onClick={() => setActiveFilter("peinture")}
                className={`px-6 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeFilter === "peinture"
                    ? "bg-[#2D2A5D] text-white"
                    : "bg-white text-gray-700 hover:bg-gray-200"
                }`}
              >
                Peinture
              </button>
              {/* <button
                onClick={() => setActiveFilter("maconnerie")}
                className={`px-6 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeFilter === "maconnerie"
                    ? "bg-[#2D2A5D] text-white"
                    : "bg-white text-gray-700 hover:bg-gray-200"
                }`}
              >
                Maçonnerie
              </button> */}
              {/* Ajoutez d'autres filtres ici */}
            </div>
          </div>
        </div>
      </section>

      {/* Liste des projets */}
      <section className="py-16 bg-white">
        <div className="container mx-auto md:px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {currentProjects.map((project) => (
              <div key={project.id} className="bg-white rounded-lg shadow-md p-6">
                <div className="flex flex-col">
                  <div className="mb-4">
                    <img
                      src={project.imageBefore}
                      alt={project.title}
                      className="w-full h-48 object-cover rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-[#2D2A5D] mb-2">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 mb-4">{project.description}</p>
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-sm text-gray-500">
                      {project.location}
                    </span>
                    <span className="text-sm text-gray-500">
                      {project.date}
                    </span>
                  </div>
                  {/* <button
                    onClick={() => setSelectedProject(project.id)}
                    className="text-red-600 hover:text-red-700 font-medium flex items-center cursor-pointer whitespace-nowrap"
                  >
                    Voir détails{" "}
                    <i className="fas fa-arrow-right ml-2"></i>
                  </button> */}
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="mt-12 flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <span className="text-gray-600">
                Affichage de {indexOfFirstProject + 1}-{Math.min(indexOfLastProject, filteredProjects.length)} sur{" "}
                {filteredProjects.length} projets
              </span>
            </div>
            <div className="flex space-x-2">
              <button
                onClick={() => paginate(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                className="px-3 py-2 bg-white border border-gray-300 rounded-l-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                <button
                  key={number}
                  onClick={() => paginate(number)}
                  className={`px-4 py-2 border border-gray-300 ${
                    currentPage === number
                      ? "bg-[#2D2A5D] text-white"
                      : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {number}
                </button>
              ))}
              <button
                onClick={() =>
                  paginate(Math.min(totalPages, currentPage + 1))
                }
                disabled={currentPage === totalPages}
                className="px-3 py-2 bg-white border border-gray-300 rounded-r-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Détails du projet sélectionné */}
      {selectedProject && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-8 relative">
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-red-600 transition-colors cursor-pointer"
            >
              <i className="fas fa-times"></i>
            </button>
            <h2 className="text-3xl font-bold text-[#2D2A5D] mb-6">
              Détails du projet
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-4">
                  Description détaillée
                </h3>
                <p className="text-gray-600">
                  {projects.find((p) => p.id === selectedProject)?.detailedDescription}
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-4">
                  Défis rencontrés
                </h3>
                <p className="text-gray-600">
                  {projects.find((p) => p.id === selectedProject)?.challenges}
                </p>
              </div>
            </div>
            <div className="mt-8">
              <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-4">
                Témoignage client
              </h3>
              <div className="flex items-start">
                <div className="bg-[#2D2A5D] text-white p-4 rounded-full mr-4">
                  <i className="fas fa-quote-left text-xl"></i>
                </div>
                <div>
                  <div className="flex items-center mb-2">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`${
                          i <
                          projects.find((p) => p.id === selectedProject)
                            ?.testimonial.rating
                            ? "fas"
                            : "far"
                        } fa-star text-yellow-500 mr-1`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-gray-600 italic mb-4">
                    "{projects.find((p) => p.id === selectedProject)?.testimonial.comment}"
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-[#2D2A5D]">
                      {projects.find((p) => p.id === selectedProject)?.testimonial.name}
                    </span>
                    <span className="text-sm text-gray-500">
                      {projects.find((p) => p.id === selectedProject)?.testimonial.date}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Call-to-Action Fixe */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 pb-6 pt-2 md:py-3 z-30">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
          <Link
            to="/services"
            className="text-[#2D2A5D] hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base hidden sm:block"
          >
            <i className="fas fa-arrow-left mr-2"></i>Voir nos services
          </Link>
          <div className="flex space-x-3 w-full sm:w-auto justify-center sm:justify-end">
            <Link
              to="/#contact"
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap flex-1 sm:flex-none text-center"
            >
              <i className="fas fa-phone-alt mr-1 md:mr-2"></i>Nous contacter
            </Link>
            <Link
              to="/"
              className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white px-3 py-2 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap flex-1 sm:flex-none text-center sm:hidden"
            >
              <i className="fas fa-home mr-1"></i>Accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Realisations;